<template>
  <div class="wg-row" :style="{height: modalHeight + 'px'}">
    <!-- Modale dettaglio log -->
    <wg-modal v-if="selected" @closeModal="closeLog">
      <div slot="header" class="wg-row com-anm22-app-text-xl" style="justify-content:center;">
        {{ $anm22.strLang(lang, 'Details', 'Dettagli') }}
      </div>
      <div class="wg-row" slot="body" :style="{height: (modalHeight - 100) + 'px'}">
        <div class="wg-row com-anm22-app-text-xl" style="justify-content:center;">
          {{ $moment.tz(selected.ts, 'X', timezone).format('LLL') + ' ' + selected.user.name + ' ' + selected.user.surname }}
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row" :style="{height: (listHeight - 60) + 'px'}">
          <w-g-list
              :pagination="true"
              :fieldInit="'ts'"
              :keyField="'id'"
              :headerItems="entriesListHeader"
              :itemsToDisplay="entriesListRows"
          >
            <template v-slot:default="{ element }">
              <div class="wg-row item-row" style="margin: 5px 0;">
                <div class="wg-col wg-xs-8" style="padding: 10px 0;">
                  <div class="wg-row" style="flex-wrap:nowrap;align-items:center;">
                    <div class="com-anm22-app-text-l">
                      {{ element.name }}
                    </div>
                  </div>
                </div>
                <div class="wg-col wg-xs-4" style="padding: 10px 0;">
                  <div class="wg-row" style="flex-wrap:nowrap;align-items:center;justify-content:flex-end;">
                    <div class="com-anm22-app-text-l">
                      {{ element.variation + ' ' + getUom(element) }}
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </w-g-list>
        </div>
      </div>
    </wg-modal>
    <div class="wg-row" style="flex-wrap:nowrap;align-items:center;justify-content:center;">
      <div class="com-anm22-app-text-l">{{ $anm22.strLang(lang, 'From', 'Da') }}</div>
      <div class="horizontal-height-div" style="width:10px;"></div>
      <input type="date" v-model="from">
      <div class="horizontal-height-div" style="width:10px;"></div>
      <div class="com-anm22-app-text-l">{{ $anm22.strLang(lang, 'To', 'A') }}</div>
      <div class="horizontal-height-div" style="width:10px;"></div>
      <input type="date" v-model="to">
      <div class="horizontal-height-div" style="width:10px;"></div>
      <input 
          type="button" 
          class="small"
          :value="$anm22.strLang(lang, 'Update', 'Aggiorna')"
          @click="loadData"
      >
    </div>
    <div class="vertical-height-div" style="height:20px;"></div>
    <div class="wg-row" :style="{ height: listHeight + 'px' }">
      <w-g-list
          :loading="loading"
          :pagination="true"
          :fieldInit="'ts'"
          :keyField="'id'"
          :clickFn="openLog"
          :headerItems="logsListHeader"
          :itemsToDisplay="logsListRows"
      >
        <template v-slot:default="{ element, data }">
          <div class="wg-row item-row" style="margin: 5px 0;">
            <div class="wg-col wg-xs-4" style="padding: 10px 0;">
              <div class="wg-row" style="flex-wrap:nowrap;align-items:center;">
                <div class="com-anm22-app-text-l">
                  {{ $moment.tz(element.ts, 'X', timezone).format('LLL') }}
                </div>
              </div>
            </div>
            <div class="wg-col wg-xs-8" style="padding: 10px 0;">
              <div class="wg-row" style="flex-wrap:nowrap;align-items:center;">
                <div class="com-anm22-app-text-l">
                  {{ data.user.name + ' ' + data.user.surname }}
                </div>
              </div>
            </div>
          </div>
        </template>
      </w-g-list>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import WGList from '../../../../../world/spa/components/WGList.vue';

export default {
  props: {
    license: {
      type: Object,
      required: true
    },
    timezone: {
      type: String,
      required: true
    }
  },
  components: {
    WGList
  },
  data() {
    return {
      loading: false,
      from: this.$moment.tz(this.timezone).format('YYYY-MM-DD'),
      to: this.$moment.tz(this.timezone).format('YYYY-MM-DD'),
      selected: null
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      lang: state => state.lang,
      licenseSelected: state => state.licenseSelected,
      windowHeight: state => state.windowHeight
    }),
    modalHeight() {
      return Math.floor(this.windowHeight * 0.9 - 90);
    },
    listHeight() {
      return this.modalHeight - 70;
    },
    logs() {
      return this.$store.getters['foodInventoryLogs/getByLicense'](this.license.id);
    },
    logsListHeader() {
      return [
        {
          field: 'ts',
          label: this.$anm22.strLang(this.lang, 'Date', 'Data'),
          class: 'wg-xs-4',
          disabled: true
        },
        {
          field: 'user',
          label: this.$anm22.strLang(this.lang, 'User', 'Utente'),
          class: 'wg-xs-8',
          disabled: false,
        },
      ]
    },
    logsListRows() {
      return this.logs.map(l => {
        return {
          ...l,
          'list-metadata': {
            type: 'item',
            user: this.$store.getters['users/get'](l.user)
          }
        }
      });
    },
    entriesListHeader() {
      return [
        {
          field: 'name',
          label: this.$anm22.strLang(this.lang, 'Name', 'Nome'),
          class: 'wg-xs-8',
          disabled: true
        },
        {
          field: 'variation',
          label: this.$anm22.strLang(this.lang, 'Variation', 'Variazione'),
          class: 'wg-xs-4',
          style: { justifyContent: 'flex-end' },
          disabled: false,
        },
      ]
    },
    entriesListRows() {
      if(this.selected) {
        return this.selected.entries.map(e => {
          return {
            id: e.id,
            name: e.productName,
            variation: e.variation,
            uom: e.productUom,
            'list-metadata': {
              type: 'item',
            }
          }
        });
      } else {
        return [];
      }
    }
  },
  methods: {
    async loadData() {
      this.loading = true;
      const response = await this.$http.get('inventory/logs', {
        params: {
          from: this.from,
          to: this.to
        }
      });
      await Promise.all([
        this.$store.dispatch('foodInventoryLogs/update', {
          vlf: this.$vlf('foodInventoryLogs'), objs: response.data.logs
        }),
        this.$store.dispatch('users/update', {
          vlf: this.$vlf('users'), objs: response.data.users
        })
      ]);
      this.loading = false;
    },
    async openLog(log) {
      const response = await this.$http.get('inventory/entries', {
        params: {
          logId: log.id
        }
      });
      await this.$store.dispatch('foodInventoryLogEntries/update', {
        vlf: this.$vlf('foodInventoryLogEntries'), objs: response.data.entries
      });
      this.selected = {
        ts: log.ts,
        user: this.$store.getters['users/get'](log.user),
        entries: this.$store.getters['foodInventoryLogEntries/getByLog'](log.id)
      };
    },
    closeLog() {
      this.selected = null;
    },
    getUom(e) {
      if(e.uom) {
        return this.$anm22.tableClasses.foodUnitOfMeasurement().getById(e.uom)['typeClassLiteral'];
      } else {
        return this.$anm22.strLang(this.lang, 'pc.', 'pz.');
      }
    },
  },
  created() {
    this.from = this.$moment().tz(this.timezone).startOf('day').format('YYYY-MM-DD');
    this.to = this.$moment().tz(this.timezone).endOf('day').format('YYYY-MM-DD');
    this.loadData();
  }
}
</script>

<style lang="scss" scoped>
.item-row {
  height: 36px;
  &:hover {
    background-color: #eee;
  }
}
</style>